<template>
  <div class="tmpList">
    <el-tabs
      v-if="pedestalConfig.homeConfig"
      v-model="activeName"
      type="card"
      @tab-click="handleClick"
    >
      <el-tab-pane
        :label="`${pedestalConfig.title}组件`"
        name="formComps"
      />
      
      <el-tab-pane
        v-for="(item,index) in pedestalConfig.customConfigList"
        :key="index"
        :label="`${item.title}`"
        name="formConfig"
      />
    </el-tabs>
    <!-- <FormSectionTitle
      :cnName="activeName == 'formComps'?`${pedestalConfig.title}组件列表`:`${pedestalConfig.title}配置`"
      :tooltip="`${pedestalConfig.title}组件建议配置20个以内，组件过多可能会影响页面加载速度。`"
    /> -->

    <draggable
      v-if="dataList.length && activeName === 'formComps'"
      v-model="dataList"
      filter=".title"
      :options="dragIssuesOptions"
      class="components-view"
      @end="onEnd"
      @start="onStart"
    >
      <div
        v-for="item in dataList"        
        :id="item.id"
        :key="item.id"
        :data-id="item.id"
        :data-name="item.name"
        :data-type="item.type"
        :class="{ 'exclusive': item.exclusive && getExclusive(item.name, updateListNum) }"
        class="dataList-item"
        :style="{ width: typeof item == `string` ? '100%' : '50%' }"
      >
        <FormSectionTitle
          v-if="typeof item == `string`"
          class="title"
          :cn-name="
            activeName == 'formComps' ? `${TmpsMap[item]}列表` : `${pedestalConfig.title}配置`
          "
          :tooltip="`${pedestalConfig.title}组件建议配置20个以内，组件过多可能会影响页面加载速度。`"
        />
        <div
          v-else
          style="width: 50%"
        >
          <TmpItem
            :cn-name="item.cnName"
            :icon="item.icon"
          />
          <span v-if="item.exclusive && getExclusive(item.name, updateListNum)">该组件唯一</span>
        </div>
      </div>
    </draggable>
    <div v-if="activeName === 'formConfig'">
      <div
        v-for="(custom, index) in pedestalConfig.customConfigList[customIndex].custom"
        :key="index"
        type="text"
        class="formConfigItem"
        @click="handleHomeConfig(custom, index)"
      >
        <FormSectionTitle
          :style="{ 'color': HomeConfigIndex == index ? '#409EFF' : '#333' }"
          class="formConfigTitle"
          :cn-name="custom.cnName"
        />
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '@/view/weappTmp/core/mixin/index.js'
import { initData } from '@/view/weappTmp/core/mixin/registerConfig.js'
import TmpStore from '@/view/weappTmp/core/lib/base/store.js'
import FormSectionTitle from '@/view/weappTmp/comps/sectionTitle/index.vue'
import TmpItem from '@/view/weappTmp/comps/tmpItem/index.vue'
import { CompsNode } from '@/view/weappTmp/core/lib/package/comps-node.js'
// const homeConfigList = [
//   {
//     title: '页面配置',
//     key: 'background'
//   },
//   {
//     title: '表单通用配置',
//     key: 'subButton'
//   },
//   {
//     title: '表单项通用配置',
//     key: 'formMargin'
//   }
//   // {
//   //   title:'表单协议',
//   //   key:'formProtocol',
//   // },
// ]
const TmpsMap = {
  'activeTmpsConfig': '页面组件',
  'formTmpsConfig': '表单控件'
}

export default {
  components: {
    FormSectionTitle,
    TmpItem
  },
  mixins: [mixin],
  props: {
    importParentAPI: {
      type: Function,
      default: () => {}
    },
    pedestalConfig: {
      type: Object
    }
  },
  data () {
    return {
      TmpsMap,
      homeConfigList:[],
      HomeConfigIndex: null,
      dataList: [],
      dragIssuesOptions: {
        group: {
          name: 'easyview',
          put: false
          // pull:'clone'
        },
        filter: '.exclusive',
        sort: false,
        fallbackClass: 'fallback-class',
        chosenClass: 'chosen-class',
        forceFallback: false
      },
      saveInit: {},
      // 缓存移步组件;
      cacheArray: {},
      updateListNum: 0,
      activeName: 'formComps',
      customIndex:null
    }
  },
  computed: {
    getExclusive () {
      return function (target, updateListNum) {
        return this.haveExclusive(target, updateListNum)
      }
    }
  },
  watch: {},
  mounted () {
    console.log('tmpList:pedestalConfig', this.pedestalConfig)
    this.initDataList()
    this.initHomeConfigList()
    let that = this
    TmpStore.$on('removeHomeComps', () => {
      that.updateListNum++
    })
  },
  methods: {
    handleHomeConfig (item, index) {
      this.HomeConfigIndex = index
      console.log('handleHomeConfig.item',this.customIndex,item)
      this.setHomeConfig(this.customIndex,item.name)
    },
    handleClick (e) {
      this.$emit('changeContent', this.activeName)
      this.customIndex = e.index - 1
      console.log('handleClick',e)
    },
    initHomeConfigList (){
      this.homeConfigList = this.pedestalConfig.homeConfigMap
    },
    // 判断当前组件是否唯一
    haveExclusive (target) {
      let components = TmpStore.getVal('components') || []
      return components.find((d) => d.name == target)
    },
    // 初始化tmpList 数据源
    initDataList () {
      const config = this.pedestalConfig
      const findTmpMap = JSON.parse(JSON.stringify(initData[config.type]))
      console.log('cmpList:findTmpMap', findTmpMap)
      // const cmpList = []
      const groupMap = {}
      for (let i in findTmpMap) {
        let cmp = findTmpMap[i],
          { name, type } = cmp
        cmp.id = `${name}_id_${this.getRandwords()}`
        
        let CMP = new CompsNode(cmp)

        if (config.notCompList.indexOf(name) == '-1') {
          // cmpList.push(cmp)
          // console.log('cmpList:groupMap1', groupMap)
          groupMap[type] ? groupMap[type].push(CMP) : (groupMap[type] = [CMP])
        }
      }
      // 对组件进行分组
      let cmpList = []
      Object.values(groupMap).forEach((g) => {
        g.unshift(g[g.length - 1].type)
        cmpList = cmpList.concat(g)
      })

      console.log('tmpList:groupMap', groupMap)
      console.log('tmpList:cmpList', cmpList)
      this.dataList = cmpList.map(d=>{
        if(!d)d=''
        return d
      })
      // this.groupMap = groupMap
      console.log('tmpList:this.dataList', this.dataList)
    },
    // 拖拽绑定事件
    onStart (evt) {
      //
      if (evt.target.className === 'components-view') {
        const needSave = this.dataList[evt.oldIndex]
        needSave.props &&
          needSave.props.forEach((d, idx) => {
            typeof d.type === 'function' && (this.cacheArray[idx] = d.type)
          })
        this.saveInit = JSON.stringify(needSave)
      } else {
        this.setCurrent(evt.oldIndex)
      }
    },
    onEnd (evt) {
      this.setCurrent(evt.newIndex, 'onEnd')
      if (evt.target.className === 'components-view' && evt.to.className === 'components-wrap') {
        const target = JSON.parse(this.saveInit)
        target.id = `${target.name}_id_${this.getRandwords()}`
        for (let i in this.cacheArray) {
          target.props[i] && (target.props[i].type = this.cacheArray[i])
        }
        this.dataList.splice(evt.oldIndex, 0, new CompsNode(target))
        // console.log('onEnd:this.dataList',this.dataList)
      }
      this.cacheArray = {}
    }
  }
}
</script>

<style lang="scss">
@import '../../../index';
.tmpList {
  background: #fff;
  min-width: 270px;
  width: 270px;
  padding: 17px 17px;
  overflow: auto;
  min-height: 695px;
  height: calc(100vh - 190px);
  .dataList-item {
    width: 50%;
    justify-content: center;
    display: flex;
  }
  // height: 600px;
  .components-view {
    width: 100%;
    // min-height: 500px;
    // height: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: baseline;
    .component-control {
      width: 33%;
    }
  }
  .formConfigItem {
    display: block;
    margin: 0;
  }
  .formConfigTitle {
    width: 240px;
    height: 40px;
    line-height: 40px;
    margin: 0;
  }
}
</style>
